import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../../styles/css/components/edit/bk-flow-edit-stay-property.css'

class BkFlowEditPropertyField extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			configData,
			hotelCode,
			handlePropertySelect
		} = this.props

		let hotelLabels = configData.hotel.labels[0],
					supportedProperties = configData.hotel.options.properties

		let propertyOptions = []

		// Construct property select options
		if ( supportedProperties ) {
			for (let property in supportedProperties) {
				propertyOptions.push(
					<option
						key={ supportedProperties[property].hotelCode }
						value={ supportedProperties[property].hotelCode }
						data-provider={supportedProperties[property].provider}
						data-theme={supportedProperties[property].theme}
					>
						{ supportedProperties[property].name }
					</option>
				)
			}
		}

		return (
			<div className="bk-flow-edit-stay__property">
				<select
					name="hotelCode"
					onChange={ (e) => handlePropertySelect( e )}
					value={ hotelCode }
					tabIndex={ 1 }
				>
					<option value='0' disabled>{ hotelLabels.selectHotelPlaceholder ? hotelLabels.selectHotelPlaceholder : 'Select Hotel' }</option>
					{ propertyOptions }
				</select>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration
})

export default connect(mapStateToProps, null)(BkFlowEditPropertyField)



// WEBPACK FOOTER //
// ./src/components/edit/property/BkFlowEditPropertyField.js